const state = {
    userInfo: {}
};
const mutations = {
    SET_USERINFO: (state, val) => {
        state.userInfo = val;
    }
};
export default {
    namespaced: true,
    state,
    mutations
};
